import { CurrencyAmountDto } from '../types/dtos/currency-amount'
import { CurrencyAmountModel } from '../types/models/currency-amount'
import { isCurrencyAmountDto } from '../utils/currency-amount'

export const transformCurrencyAmountDto = ({
  amount,
  currency_code,
}: CurrencyAmountDto): CurrencyAmountModel => {
  return {
    amount,
    currencyCode: currency_code,
  }
}

export const transformCurrencyAmountDtoOrString = (
  dtoOrString: CurrencyAmountDto | string,
  fallbackCurrencyCode: string,
): CurrencyAmountModel => {
  if (isCurrencyAmountDto(dtoOrString)) return transformCurrencyAmountDto(dtoOrString)

  return {
    amount: dtoOrString,
    currencyCode: fallbackCurrencyCode,
  }
}
